import AlgoliaConfig from "controller/algolia/algoliaConfig";
import { autocomplete, getAlgoliaResults } from '@algolia/autocomplete-js';
import { createRedirectUrlPlugin } from '@algolia/autocomplete-plugin-redirect-url';
import algoliaSearch from "algoliasearch/lite";
import $ from 'jquery';
import Swiper from "swiper";
import { Navigation, Mousewheel } from 'swiper/modules';

export default class AlgoliaAutocompleteV2
{
    constructor()
    {
        this.algoliaConfig = new AlgoliaConfig();
        this.algoliaQuery = '';
    }

    debouncePromise(fn, time)
    {
        let timer = undefined;

        return function debounced(...args)
        {
            if (timer) {
                clearTimeout(timer); // Clear the timeout first if it's already defined.
            }

            return new Promise((resolve) => {
                timer = setTimeout(() => resolve(fn(...args)), time);
            });
        };
    }

    initialiseSwiper(className, direction, hasNavigation = false) {
        this.swiper = this.swiperSettings(className, direction, hasNavigation);
    }

    swiperSettings(selector, direction, hasNavigation) {
        const navigation = hasNavigation ?
            { navigation: { prevEl: '.swiper-button-prev', nextEl: '.swiper-button-next' }} :
            {};
        const modules = hasNavigation ? [Navigation, Mousewheel] : [Mousewheel];
        return new Swiper(selector, {
            direction: direction || 'horizontal',
            modules,
            slidesPerView: 'auto',
            spaceBetween: 12,
            freeMode: true,
            mousewheel: {
                forceToAxis: true,
                releaseOnEdges: true,
            },
            simulateTouch: true,
            grabCursor: true,
            ...navigation,
        });
    }

    setupEvents()
    {
        $('body').on('click', '.aa-ClearButton', function(){
            $('body').find('.aa-DetachedOverlay').remove();
            $('body').removeClass('aa-Detached');
        });
        $('body').on('keydown', function(e) {
            if (e.key === 'Enter') {
                let $selectedItem = $('.aa-Item[aria-selected="true"]');
                if ($selectedItem.length > 0) {
                    let $link = $selectedItem.find('a');
                    let href = $link.attr('href');
                    //Open blog posts in new tab, other links open in same tab.
                    if (href) {
                        e.preventDefault();
                        if ($selectedItem.find('.aa-inspiration-content').length > 0) {
                            window.open(href, '_blank');
                        } else {
                            window.location.href = href;
                        }
                    }
                }
            }
        });
    }
    startAutocomplete()
    {
        const defaultAlgoliaStallThreshold = 200;
        const searchClient = algoliaSearch(this.algoliaConfig.appId, this.algoliaConfig.apiKey);
        const redirectUrlPlugin = createRedirectUrlPlugin();
        const searchPageURL = "/search/";
        const debounceMS = this.algoliaConfig.debounceMS;
        const debounced = this.debouncePromise((items) => Promise.resolve(items), debounceMS);
        const productsIndex = this.algoliaConfig.getIndex();
        const suggestionsIndex = this.algoliaConfig.getSuggestionsIndex();
        const categoryIndex = this.algoliaConfig.getCategoryIndex();
        const blogPostsIndex = this.algoliaConfig.getBlogPostsIndex();
        const trackingEnabled = this.algoliaConfig.isTrackingEnabled();
        let me = this;
        if ($("#autocomplete").length) {
            autocomplete({
                container: "#autocomplete",
                // Recommended to be 300ms more than the Debounce MS value.
                stallThreshold: debounceMS > 0 ? debounceMS + 300 : defaultAlgoliaStallThreshold,
                sourceId: 'websiteHeaderSearch',
                openOnFocus: false,
                plugins: [redirectUrlPlugin],
                insights: trackingEnabled,
                placeholder: 'Search...',
                classNames: {
                    panel: 'aa-Panel typeahead-test',
                    detachedCancelButton: 'hide'
                },
                onSubmit({ state }) {
                    window.location.assign(searchPageURL + encodeURIComponent(state.query.trim()));
                },
                render(props, root) {
                    const {
                        state,
                        elements,
                        html,
                        render
                    } = props;
                    // Update the query to the latest one.
                    me.algoliaQuery = state.query;
                    // Remove all the existing sections.
                    render(
                        html`
                            ${Object.entries(elements).map(([sectionName, sectionBody]) => html`
                                <div class="aa-${sectionName} swiper-slide ${sectionName === 'categories' ? 'hide' : ''}">
                                    ${sectionName === 'categories'
                                        ? html`
                                            <div class="swiper-categories">
                                                <ul class="swiper-wrapper aa-List">
                                                    ${sectionBody.props.children[1].props.children.map(item => html`
                                                        <li class="swiper-slide aa-Item">
                                                            <div class="aa-ItemContent">
                                                                ${item.props.children}
                                                            </div>
                                                        </li>
                                                    `)}
                                                </ul>
                                                <div class="swiper-button-prev"></div>
                                                <div class="swiper-button-next"></div>
                                            </div>`
                                        : sectionBody
                                    }
                                </div>
                            `)}
                        `,
                        root
                    );
                    // Initialise the swipers.
                },
                getSources({ query }) {
                    return debounced([
                        {
                            sourceId: 'suggestions',
                            getItems() {
                                return getAlgoliaResults({
                                    searchClient,
                                    queries: [{ indexName: suggestionsIndex, query}],
                                });
                            },
                            templates: {
                                header() {
                                    return 'Suggested';
                                },
                                item({ item, components, html }) {
                                    let totalHits = item[productsIndex].exact_nb_hits;
                                    return html`<div className="aa-ItemWrapper type-ahead">
                                        <div className="aa-ItemContent">
                                            <a href="${searchPageURL}${item.query}" aria-label="${item.objectID} ${item}">
                                                <div className="aa-ItemContentBody">
                                                    <div className="aa-ItemContentTitle">
                                                        <span className="aa-ItemTitle">${components.Highlight({ hit: item, attribute: 'query' })}</span>
                                                        <span className="aa-ItemTotalHits">${totalHits} results</span>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    </div>`;
                                },
                            },
                        },
                        {
                            sourceId: 'products',
                            getItems() {
                                return getAlgoliaResults({
                                    searchClient,
                                    queries: [{ indexName: productsIndex, query}],
                                });
                            },
                            templates: {
                                header ({state, html = ''}) {
                                    return html `Products <a class="float-right aa-Item" href="/search/${encodeURIComponent(state.query)}" role="option" aria-label="View All">View all</a>`;
                                },
                                item({ item, components, html = '' }) {
                                    let savingText = item.saving > 0 ? "Save £" + item.saving : '';
                                    return html `<div className="aa-ItemContent">
                                        <a href="${item.url}" aria-label="${item.name}">
                                            <div className="aa-ItemContentBody product">
                                                <div class="aa-product-image-wrapper">
                                                    <img className="aa-product-image" src="${item.image}" alt="${item.altTag}" />
                                                </div>
                                                <div className="aa-product-description">
                                                    <div className="aa-ItemContentTitle">
                                                        ${components.Highlight({ hit: item, attribute: 'namePart1' })} ${components.Highlight({ hit: item, attribute: 'namePart3' })}
                                                    </div>
                                                    <div className="aa-ItemContentSubTitle">${components.Highlight({ hit: item, attribute: 'namePart2' })}</div>
                                                    <div className="aa-ItemContentPurchasePrice">£${item.purchasePrice} <span>${savingText}</span></div>
                                                </div>
                                            </div>
                                        </a>
                                    </div>`;
                                },
                            },
                        },
                        // End static content
                        {
                            sourceId: 'posts',
                            getItems() {
                                return getAlgoliaResults({
                                    searchClient,
                                    queries: [{ indexName: blogPostsIndex, query}],
                                });
                            },
                            templates: {
                                header() {
                                    return 'Inspiration';
                                },
                                item({ item, components, html = '' }) {
                                    return html `<div className="aa-inspiration-content">
                                        <a href="${item.permalink}" target="_blank" aria-label="${item.post_title}">
                                            <div className="aa-inspiration-body">
                                                <div className="aa-inspiration-title">${components.Highlight({ hit: item, attribute: 'post_title' })}</div>
                                                <img className="aa-inspiration-image" src="${item.images.thumbnail.url}" alt="${item.post_title}" />
                                            </div>
                                        </a>
                                    </div>`;
                                },
                            },
                        },
                    ]);
                },
            });
        }
        this.setupEvents();
    }

}